import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

// Get all subscriptions with optional parameters
export const useGetSubscriptionsQuery = (params = {}) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_SUBSCRIPTIONS, params], // Include params in queryKey for caching
    queryFn: () => {
      // Build query string from params
      const searchParams = new URLSearchParams();
      
      if (params.subscriptionType) {
        searchParams.append("subscriptionType", params.subscriptionType);
      }
      
      if (params.status) {
        searchParams.append("status", params.status);
      }
      
      // Add any other parameters you might need
      Object.keys(params).forEach(key => {
        if (params[key] && !['subscriptionType', 'status'].includes(key)) {
          searchParams.append(key, params[key]);
        }
      });
      
      const queryString = searchParams.toString();
      const url = queryString ? `${API_ROUTES.GET_SUBSCRIPTIONS}?${queryString}` : API_ROUTES.GET_SUBSCRIPTIONS;
      
      return api.get(url);
    },
  });

  return {
    data: data?.data?.data ?? [],
    isPending,
    isError,
    error,
  };
};